import { put, takeLatest, select } from "redux-saga/effects";
import {
  fetchFilesRequest,
  fetchFilesSuccess,
  fetchFilesFailure,
  uploadFileRequest,
  uploadFileSuccess,
  uploadFileFailure,
} from "./filesSlice";
import baseURL from "../../utils/config";
import TokenManager from "../../utils/tokenManager";


function* fetchFilesSaga(action) {
  try {
    const { threadId } = action.payload;
    const token = TokenManager.getAccessToken(); 

    const url = threadId ? `${baseURL}/api/files?thread_id=${threadId}` : `${baseURL}/api/files`;
    const response = yield fetch(url, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`, // Replaces X-User-ID
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to load documents: ${response.status}`);
    }

    const data = yield response.json();

    // Format documents for the sidebar
    const formatFileSize = (bytes) => {
      if (!bytes) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return (
        Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i]
      );
    };

    const formattedFiles = data.files.map((file) => ({
      id: file.file_id,
      title: file.filename,
      type: file.contentType?.split("/")[1]?.toUpperCase() || "FILE",
      createdAt: new Date(file.upload_time).toLocaleDateString(),
      size: formatFileSize(file.file_size),
      file_id: file.file_id,
    }));

    yield put(fetchFilesSuccess({ threadId, files: formattedFiles }));
  } catch (error) {
    console.error("Error in fetchFilesSaga:", error);
    yield put(fetchFilesFailure(error.message));
  }
}

function* uploadFileSaga(action) {
  try {
    const { file, threadId } = action.payload;
    const token = TokenManager.getAccessToken();

    const formData = new FormData();
    formData.append("file", file);

    const uploadUrl = threadId ? `${baseURL}/api/files?thread_id=${threadId}` : `${baseURL}/api/files`;

    const response = yield fetch(uploadUrl, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`, 
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`File upload failed: ${response.status}`);
    }

    const uploadData = yield response.json();

    const formatFileSize = (bytes) => {
      if (!bytes) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return (
        Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i]
      );
    };

    const formattedFile = {
      id: uploadData.file_id,
      title: uploadData.filename,
      type: uploadData.contentType?.split("/")[1]?.toUpperCase() || "FILE",
      createdAt: new Date().toLocaleDateString(),
      size: formatFileSize(uploadData.file_size),
      file_id: uploadData.file_id,
    };

    yield put(uploadFileSuccess({ threadId, file: formattedFile }));
    if (action.payload.onSuccess) {
      action.payload.onSuccess(uploadData.file_id); 
    }
  } catch (error) {
    console.error("Error in uploadFileSaga:", error);
    yield put(uploadFileFailure(error.message));
  }
}

export function* watchFilesSaga() {
  yield takeLatest(fetchFilesRequest, fetchFilesSaga);
  yield takeLatest(uploadFileRequest, uploadFileSaga);
}

